import React from "react";
import { MapPin, Mail, Globe } from "lucide-react";
import { CONTACT, FOOTER } from "../mock";

// Simplified Isle of Man outline
const IsleOfManMap = () => (
  <svg width="120" height="150" viewBox="0 0 120 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64 6c4 5 3 14 8 20 6 7 15 10 18 19 3 8-1 17-3 25-3 11-3 23-9 33-5 9-15 14-22 22-5 6-7 15-14 19-6 3-13-1-16-7-4-8 1-17-1-25-2-9-9-16-10-26-1-9 4-18 9-25 6-9 8-20 15-28 6-7 15-11 20-19 2-4 2-10 5-8z"
      stroke="#8b95a3"
      strokeWidth="1.4"
      fill="none"
    />
  </svg>
);

const Footer = () => (
  <footer>
    {/* corporate enquiries block */}
    <div style={{ background: "#eceae7" }} className="py-16">
      <div className="si-container grid lg:grid-cols-2 gap-12">
        <div>
          <ul className="space-y-4">
            <li className="flex items-start gap-3" style={{ color: "#3f4b5a" }}>
              <MapPin size={20} className="text-[#e8730c] mt-0.5 shrink-0" />
              <span style={{ fontSize: 16 }}>
                {CONTACT.company}
                <br />
                {CONTACT.location}
              </span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#3f4b5a" }}>
              <Mail size={20} className="text-[#e8730c] shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-[#e8730c] transition-colors" style={{ fontSize: 16 }}>
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#3f4b5a" }}>
              <Globe size={20} className="text-[#e8730c] shrink-0" />
              <span style={{ fontSize: 16 }}>{CONTACT.website}</span>
            </li>
          </ul>
        </div>

        <div className="flex items-center gap-8 lg:justify-end lg:border-l lg:border-[#d3cfc8] lg:pl-12">
          <IsleOfManMap />
          <div>
            <p className="font-semibold" style={{ color: "#16233a", fontSize: 18 }}>
              {CONTACT.companyNo}
            </p>
            <p className="mt-3 max-w-xs" style={{ color: "#4a5666", fontSize: 16, lineHeight: 1.6 }}>
              {CONTACT.incorporation}
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* bottom bar */}
    <div style={{ background: "#0d1b2e" }} className="py-5">
      <div className="si-container text-center">
        <p style={{ color: "#8f9bab", fontSize: 14, letterSpacing: "0.03em" }}>
          {FOOTER.copyright}
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
